import EzModalController from 'layouts/modal/modal-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { JOIN_PRO_TRIGGERED, JOIN_PRO_COMPLETE } from 'components/analytics/conversions/constants/actions';

export default class DailyLimitJoinProModalController extends EzModalController {
  category = 'Trigger-Download_Limit-10';

  connect() {
    super.connect();

    sendTrackingEvent({
      data: {
        action: JOIN_PRO_TRIGGERED,
        category: this.category,
        label: 'Free',
        non_interaction: true,
      },
    });
  }

  trackClick() {
    sendTrackingEvent({
      data: {
        action: JOIN_PRO_COMPLETE,
        category: this.category,
      },
    });
  }
}
